<template>
  <section class="news-focus" :style="sectionStyle">
    <div class="container">
      <div class="news-focus__top">
        <div class="news-focus__header">
          <h2 class="section-title">新闻焦点</h2>
          <a href="javascript:void(0);" class="news-focus__more" @click="goToNews">更多</a>
        </div>
        <div class="news-focus__content">
          <div class="news-focus__qrcode">
            <img src="@/assets/banners/banner1.png" alt="新闻图片">
          </div>
          <div class="news-focus__tabs">
            <div class="news-focus__tabs-header">
              <button
                v-for="tab in tabs"
                :key="tab.id"
                class="news-focus__tab-btn"
                :class="{ active: activeTab === tab.id }"
                @click="activeTab = tab.id"
              >
                {{ tab.name }}
              </button>
              <a href="javascript:void(0);" class="news-focus__more" @click="goToNewsWithTab">更多</a>
            </div>
            <div class="news-focus__tab-content">
              <ul class="news-focus__list">
                <li v-for="item in currentTabData" :key="item.id" class="news-focus__list-item" @click="goToArticle(item.id)">
                  <a href="javascript:void(0);" class="news-focus__list-link">{{ item.title }}</a>
                  <span class="news-focus__list-date">{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="news-focus__bottom">
        <div class="news-focus__column">
          <div class="news-focus__column-header">
            <h3 class="news-focus__column-title">{{ guideTitle }}</h3>
            <a href="javascript:void(0);" class="news-focus__more" @click="goToNewsWithGuide">更多</a>
          </div>
          <ul class="news-focus__list">
            <li v-for="item in guideData" :key="item.id" class="news-focus__list-item" @click="goToArticle(item.id)">
              <a href="javascript:void(0);" class="news-focus__list-link">{{ item.title }}</a>
              <span class="news-focus__list-date">{{ item.date }}</span>
            </li>
          </ul>
        </div>
        <div class="news-focus__column">
          <div class="news-focus__column-header">
            <h3 class="news-focus__column-title">{{ policyTitle }}</h3>
            <a href="javascript:void(0);" class="news-focus__more" @click="goToNewsWithPolicy">更多</a>
          </div>
          <ul class="news-focus__list">
            <li v-for="item in policyData" :key="item.id" class="news-focus__list-item" @click="goToArticle(item.id)">
              <a href="javascript:void(0);" class="news-focus__list-link">{{ item.title }}</a>
              <span class="news-focus__list-date">{{ item.date }}</span>
            </li>
          </ul>
        </div>
        <div class="news-focus__column">
          <div class="news-focus__column-header">
            <h3 class="news-focus__column-title">{{ downloadTitle }}</h3>
            <a href="javascript:void(0);" class="news-focus__more" @click="goToDownloads">更多</a>
          </div>
          <ul class="news-focus__list">
            <li v-for="item in downloadData" :key="item.id" class="news-focus__list-item" @click="goToArticle(item.id)">
              <a href="javascript:void(0);" class="news-focus__list-link">{{ item.title }}</a>
              <span class="news-focus__list-date">{{ item.date }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { articleApi, articleCatApi } from '../../api'
import row4Bg from '@/assets/row4_bg.png'

export default {
  name: 'NewsFocus',
  data() {
    return {
      activeTab: 'gov',
      tabs: [
        { id: 'gov', name: '政务要闻', catId: '' },
        { id: 'company', name: '我院动态', catId: '' },
        { id: 'notice', name: '通知公告', catId: '' }
      ],
      guideTitle: '办事指南',
      guideCatId: '',
      policyTitle: '政策法规',
      policyCatId: '',
      downloadTitle: '资料下载',
      downloadCatId: '',
      tabDataByIndex: [
        [
        ],
        [
        ],
        [
        ]
      ],
      guideData: [
      ],
      policyData: [
      ],
      downloadData: [
      ]
    }
  },
  computed: {
    sectionStyle() {
      return {
        backgroundImage: `
          linear-gradient(rgba(248, 249, 250, 0.92), rgba(248, 249, 250, 0.92)),
          url(${row4Bg})
        `
      }
    },
    currentTabData() {
      const activeIndex = this.tabs.findIndex(tab => tab.id === this.activeTab)
      return this.tabDataByIndex[activeIndex] || []
    }
  },
  mounted() {
    this.fetchArticleCats()
  },
  methods: {
    async fetchArticleCats() {
      try {
        const [newsRes, downloadRes] = await Promise.all([
          articleCatApi.dataByPcode('news'),
          articleCatApi.dataByCode('download')
        ])

        const newsCats = this.parseCatList(newsRes)
        const downloadCat = this.parseCatObject(downloadRes)

        if (newsCats.length > 0) {
          const topTabs = newsCats.slice(0, 3).map(item => ({
            id: item.code || String(item.id),
            name: item.name || '',
            catId: item.id
          }))

          if (topTabs.length > 0) {
            this.tabs = topTabs
            this.activeTab = topTabs[0].id
          }

          if (newsCats[3] && newsCats[3].name) {
            this.guideTitle = newsCats[3].name
            this.guideCatId = newsCats[3].id
          }

          if (newsCats[4] && newsCats[4].name) {
            this.policyTitle = newsCats[4].name
            this.policyCatId = newsCats[4].id
          }
        }

        if (downloadCat && downloadCat.name) {
          this.downloadTitle = downloadCat.name
          this.downloadCatId = downloadCat.id
        }

        await this.fetchArticleLists(newsCats, downloadCat)
      } catch (error) {
        console.error('获取文章分类失败:', error)
      }
    },
    async fetchArticleLists(newsCats, downloadCat) {
      const firstThreeCats = newsCats.slice(0, 3)
      const guideCat = newsCats[3]
      const policyCat = newsCats[4]

      const [tab0, tab1, tab2, guideList, policyList, downloadList] = await Promise.all([
        this.fetchArticlesByCatId(firstThreeCats[0] && firstThreeCats[0].code),
        this.fetchArticlesByCatId(firstThreeCats[1] && firstThreeCats[1].code),
        this.fetchArticlesByCatId(firstThreeCats[2] && firstThreeCats[2].code),
        this.fetchArticlesByCatId(guideCat && guideCat.code),
        this.fetchArticlesByCatId(policyCat && policyCat.code),
        this.fetchArticlesByCatId(downloadCat && downloadCat.code)
      ])

      this.tabDataByIndex = [tab0, tab1, tab2]
      this.guideData = guideList
      this.policyData = policyList
      this.downloadData = downloadList
    },
    async fetchArticlesByCatId(code) {
      if (!code) {
        return []
      }

      try {
        const response = await articleApi.data({ code })
        const list = this.parseArticleList(response)
        return list.map((item) => ({
          id: item.id,
          title: item.title || '',
          date: this.formatArticleDate(item)
        })).filter(item => item.id)
      } catch (error) {
        console.error('获取文章列表失败:', error)
        return []
      }
    },
    parseCatList(response) {
      if (response && response.code === 0 && Array.isArray(response.data)) {
        return response.data
      }
      if (Array.isArray(response)) {
        return response
      }
      return []
    },
    parseCatObject(response) {
      if (response && response.code === 0 && response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        return response.data
      }
      if (response && typeof response === 'object' && !Array.isArray(response)) {
        return response
      }
      return null
    },
    parseArticleList(response) {
      if (response && response.code === 0 && Array.isArray(response.data)) {
        return response.data
      }
      if (Array.isArray(response)) {
        return response
      }
      return []
    },
    formatArticleDate(item) {
      const rawDate = item.titleDate || item.crTime || item.upTime
      if (!rawDate) {
        return ''
      }
      const date = new Date(rawDate)
      if (Number.isNaN(date.getTime())) {
        return String(rawDate).slice(0, 10)
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    goToArticle(id) {
      if (!id) {
        return
      }
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'article', articleId: id }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 跳转到新闻资讯页面
    goToNews() {
      const firstTab = this.tabs[0]
      const catId = firstTab ? firstTab.catId : ''
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'news', catId: catId }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 跳转到新闻资讯页面并带上当前选中的tab的catId
    goToNewsWithTab() {
      const currentTab = this.tabs.find(tab => tab.id === this.activeTab)
      const catId = currentTab ? currentTab.catId : ''
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'news', catId: catId }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 跳转到新闻资讯页面并带上办事指南的catId
    goToNewsWithGuide() {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'news', catId: this.guideCatId }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 跳转到新闻资讯页面并带上政策法规的catId
    goToNewsWithPolicy() {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'news', catId: this.policyCatId }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 跳转到资料下载页面
    goToDownloads() {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'downloads' }
      }))
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.news-focus {
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: clamp(24px, 4vh, 40px) 0;
  background-color: #f8f9fa;
  background-size: cover;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.section-title {
  font-size: 32px;
  margin-bottom: 22px;
  color: #333;
  font-weight: 700;
}

.news-focus__top {
  margin-bottom: 24px;
}

.news-focus__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.news-focus__more {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.news-focus__more:hover {
  text-decoration: underline;
}

.news-focus__content {
  display: flex;
  gap: 24px;
  background-color: #fff;
  padding: 20px 24px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.news-focus__qrcode {
  flex: 0 0 160px;
  text-align: center;
  padding-top: 12px;
}

.news-focus__qrcode img {
  width: 130px;
  height: 240px;
  object-fit: cover;
}

.news-focus__tabs {
  flex: 1;
}

.news-focus__tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.news-focus__tab-btn {
  background: none;
  border: none;
  padding: 6px 12px;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news-focus__tab-btn:hover {
  color: #007bff;
}

.news-focus__tab-btn.active {
  color: #007bff;
  font-weight: 600;
  border-bottom: 2px solid #007bff;
}

.news-focus__tab-content {
  max-height: 220px;
  overflow-y: auto;
}

.news-focus__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.news-focus__list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.news-focus__list-item:last-child {
  border-bottom: none;
}

.news-focus__list-link {
  color: #333;
  text-decoration: none;
  font-size: 13px;
  line-height: 1.45;
  flex: 1;
  margin-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-focus__list-link:hover {
  color: #007bff;
}

.news-focus__list-date {
  font-size: 11px;
  color: #999;
  flex: 0 0 88px;
  text-align: right;
}

.news-focus__bottom {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.news-focus__column {
  background-color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.news-focus__column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #007bff;
}

.news-focus__column-title {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin: 0;
}

@media (max-width: 768px) {
  .news-focus {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .news-focus__content {
    flex-direction: column;
    padding: 20px;
  }
  
  .news-focus__qrcode {
    flex: 0 0 auto;
    margin-bottom: 20px;
  }
  
  .news-focus__qrcode img {
    width: 120px;
    height: 120px;
  }
  
  .news-focus__bottom {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .news-focus__column {
    padding: 15px;
  }
  
  .news-focus__column-title {
    font-size: 16px;
  }
  
  .news-focus__list-link {
    font-size: 13px;
  }
  
  .news-focus__list-date {
    flex: 0 0 80px;
    font-size: 11px;
  }
}
</style>
